import QuestionValue from "../QuestionValue";
import QuestionModule from "./QuestionModule";

export default class QuestionModuleTimesTable extends QuestionModule {
    constructor() {
        super();
    }

    create(data) {
        const question = super.create(data);

        question.part = 2;

        question.values[0] = new QuestionValue(P3.utils.selectRandom(question.range.left));
        question.values[1] = new QuestionValue(P3.utils.selectRandom(question.range.right));
        question.values[2] = new QuestionValue(question.values[0] * question.values[1]);

        return question;
    }
}